type TPrimitive = string | number;
type TArgument<T extends TPrimitive> = T | `${T}` | TOperator<T>;
type TOperator<T extends TPrimitive> = (values: T | T[] | `${T}` | `${T}`[]) => boolean;

// intersection(args, values) === args
const and =
  <T extends TPrimitive>(...args: TArgument<T>[]): TOperator<T> =>
  (values) =>
    args.every((arg) => {
      if (typeof arg === 'function') {
        return arg(values);
      }

      if (Array.isArray(values)) {
        // @ts-expect-error: ok
        return values.includes(arg);
      }

      return values === arg;
    });

// intersection(args, values).length > 0
const or =
  <T extends TPrimitive>(...args: TArgument<T>[]): TOperator<T> =>
  (values) =>
    args.some((arg) => {
      if (typeof arg === 'function') {
        return arg(values);
      }

      if (Array.isArray(values)) {
        // @ts-expect-error: ok
        return values.includes(arg);
      }

      return values === arg;
    });

// !values.includes(arg)
const not =
  <T extends TPrimitive>(arg: TArgument<T>): TOperator<T> =>
  (values) => {
    if (typeof arg === 'function') {
      return !arg(values);
    }

    if (Array.isArray(values)) {
      // @ts-expect-error: ok
      return !values.includes(arg);
    }

    return values !== arg;
  };

// true
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const any = (): TOperator<any> => () => true;

// false
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const never = (): TOperator<any> => () => false;

export {and, or, not, any, never};
export type {TOperator};
